let elementsSelector = '.js-readmore';
let openClass = 'open';
let textLess = 'Свернуть';
let duration = 300;
let btnSelector = '.js-readmore-btn';

var $dots = $(elementsSelector);

initElements();
updateDotAfterLoadFonts();


function initElements() {
	
	$dots.each(function (i, el) {
		
		var $element = $(el);
		var $btn = $element.next(btnSelector);
		var $dot = $element.children();
		
		$dot.dotdotdot({
			height: 'watch',
			watch: true,
			callback: function (isTruncated) {
				
				if (typeof $.fn.matchHeight === 'function') {
					$.fn.matchHeight._update();
				}
				
				// Скрываем кнопку, если ничего не обрезали (мало текста)
				if (isTruncated) {
					$btn.show();
				} else {
					$btn.hide();
				}
				
			},
		});
		
		
		$btn.click(function (e) {
			toggle($element);
		});
		
	});
	
}

function updateDotAfterLoadFonts() {
	
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	
	if (!isIE11) {
		
		// Перерасчет высоты после загрузки шрифта
		document.fonts.ready.then(function (a, $element) {
			
			$dots.each(function (i, el) {
				
				var $dot = $(el).children();
				var dotAPI = $dot.data('dotdotdot');
				
			});
			
		});
		
	}
	
}

// Развертывание элемента
function more($readMoreWrapEl) {
	
	var $dot = $readMoreWrapEl.children();
	var dotAPI = $dot.data('dotdotdot');
	var $readMoreEl = $readMoreWrapEl.children();
	var $btn = $readMoreWrapEl.next(btnSelector);
	
	if (!$readMoreWrapEl.hasClass(openClass) && $readMoreWrapEl.css('max-height') == 'none') {
		
		$btn.data('text-more', $btn.text().trim());
		$btn.data('html-more', $btn.html());
		
		$readMoreWrapEl.addClass(openClass);
		updateBtnText($btn, textLess);
		
		var height = $readMoreWrapEl.height();
		dotAPI.restore();
		
		$readMoreWrapEl.css('max-height', height);
		
		$readMoreWrapEl.stop().animate({
			'max-height': $readMoreEl.height(),
		}, {
			'duration': duration,
			'complete': function () {
				$(this).css('max-height', '');
			}
		});
		
	}
	
}

// Свертывание элемента
function less($readMoreWrapEl) {
	
	if (typeof scroll === 'undefined') {
		var scroll = true;
	}
	
	var $dot = $readMoreWrapEl.children();
	var dotAPI = $dot.data('dotdotdot');
	var $readMoreEl = $readMoreWrapEl.children();
	var $btn = $readMoreWrapEl.next(btnSelector);
	
	if ($readMoreWrapEl.hasClass(openClass) && $readMoreWrapEl.css('max-height') == 'none') {
		
		updateBtnText($btn, $btn.data('text-more'));
		
		$readMoreWrapEl.removeClass(openClass);
		dotAPI.truncate();
		var maxHeight = $readMoreEl.height();
		dotAPI.restore();
		$readMoreWrapEl.addClass(openClass);
		
		var height = $readMoreEl.height();
		$readMoreWrapEl.css('max-height', height);
		
		if (scroll) {
			toScroll($btn, $readMoreEl, maxHeight);
		}
		
		$readMoreWrapEl.stop().animate({
			'max-height': maxHeight,
		}, {
			'duration': duration,
			'complete': function () {
				$readMoreWrapEl.removeClass(openClass);
				$(this).css('max-height', '');
				dotAPI.truncate();
				dotAPI.watch();
			}
		});
		
	}
	
	function toScroll($el, $box, maxHeight) {
		
		var headerHeight = 100;
		var scrollPosition = 0;
		var paddingTop = -20; // дополнительный визуальный отступ от шапки
		var $animateElement = '';
		var $scrollElement = $(document);
		
		var height = $box.height();
		
		var withinviewportSettings = {
			top: headerHeight + height,
			container: $scrollElement[0],
		};
		
		var elementIsViewport = $el.withinviewport(withinviewportSettings).length > 0;
		
		if (!elementIsViewport) {
			
			// если шапка зафиксирована, то учитываем это
			if (false) {
				paddingTop -= headerHeight;
			}
			
			$animateElement = $('html, body');
			
			scrollPosition = ($el.offset().top - (height - maxHeight)) + paddingTop;
			
			var isBodyOverflowHidden = ($('body').css('overflow') === 'hidden')
			
			if (!isBodyOverflowHidden) {
				$animateElement.stop().animate({scrollTop: scrollPosition}, scrollDuration);
			}
			
			
		}
		
	}
	
}

// Переключение состояния элемента
function toggle($readMoreWrapEl) {
	
	if (!$readMoreWrapEl.hasClass(openClass)) {
		more($readMoreWrapEl);
	} else {
		less($readMoreWrapEl);
	}
	
}

// Обновление текста кнопки
function updateBtnText($btn, text) {
	
	var htmlBtn = $btn.html();
	var textMore = $btn.data('text-more');
	var htmlMore = $btn.data('html-more');
	
	if (htmlBtn === htmlMore) {
		htmlBtnNew = htmlBtn.replace(textMore, text);
	} else {
		htmlBtnNew = htmlMore;
	}
	
	
	$btn.html(htmlBtnNew);
	
}